import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  background-color: ${Colors.White};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  align-items: flex-start;
  gap: 24px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const Header = styled.div`
  ${Typography.M};
  ${FontWeights.DemiBold};
  mix-blend-mode: normal;
  text-align: center;
  margin-bottom: 24px;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`

export const FieldContainer = styled.div`
  height: 66px;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 15px;
  justify-content: space-between;
  gap: 12px;
`
